import Rollbar from 'rollbar';
import { ERROR_CODES } from '@widergy/web-utils';

import store from 'redux/store';

export const pollingFailureCallback = (response, error) => {
  if (error && error.name === ERROR_CODES.POLLING_TIMEOUT) {
    Rollbar.info('polling timeout', {
      originalEndpoint: error.originalUrl,
      pollingEndpoint: response.config.url,
      userID: store.getState().auth.currentUser && store.getState().auth.currentUser.id,
      accountID: store.getState().account.currentAccount && store.getState().account.currentAccount.id,
      timeout: error.timeout
    });
  }
};
